<template>
  <div>

  <header>
            <Header
        :HideCart='true'
        Title='Pagamento'
        class="mb-5" 
        />
  </header>

  <section style="max-height:99vh">


    <form class='register'>



      <CenteredFigure
      class='centered'
      :Img='PaymentImg'
      />

      <TitleH1
      class='titleh1 ml-5 '
      Text='Escolha a forma de pagamento'
      />
  
<FooterContainer>



        <ButtonOutline
        id='first_button'
        Type='submit'
        Text='PIX'
        :ButtonFunction='next_step'
        />
        <ButtonOutline
        id='first_button'
        Type='submit'
        Text='DINHEIRO'
        :ButtonFunction='next_step'
        />
        <ButtonOutline
        id='first_button'
        Type='submit'
        Text='CARTÃO'
        :ButtonFunction='next_step'
        />



</FooterContainer>

    </form>

  </section>
  </div> 
</template>

<script>

import Header from '../../components/Header/Header'
import PaymentImg from '../../assets/img/paymentOptions.svg'
import CenteredFigure from '../../components/ImageStyle/CenteredFigure'
import TitleH1 from '../../components/Title/TitleH1'
import ButtonOutline from '../../components/Button/ButtonCallToActionOutline'
import FooterContainer from '../../components/Container/FooterContainer'

export default {
  components: {

    Header,
    TitleH1,
    CenteredFigure,
    ButtonOutline,
    FooterContainer,
  },
  data() {
    return {
      PaymentImg: PaymentImg,
      form: {
        nome: '',
        email: '',
        celular: '',
      }
    }
  },
  methods: {
    next_step() {
      console.log('next step', this.form.nome, this.form.email,this.form.celular)
    }
  },
}
</script>

<style scoped lang="css">



.titleh1{
  display: flex;
  align-items: center;
  text-align: center;
}

.inputName{
  margin-top:5.25rem;
}

#first_button{
  margin-bottom:.5rem;
}
  .register{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:6.25rem;  
}

  @media (min-width: 1400px) and (max-width: 2600px) {
  .register{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }
</style>
